import styled from 'styled-components';
import { Avatar } from '@ann/web-components';

export const AutocompleteContainer = styled.div`
  width: 100%;

  & > div {
    width: 100%;
  }

  & > div > div {
    width: 100%;
  }
`;

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const WorkspaceListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  max-height: 280px;
  padding: 0 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;

export const CurrentWorkspaceText = styled.div`
  visibility: hidden;
  display: flex;
  align-items: center;
  padding-right:16px;
  
  span {
    display: inline-block;
  }
`;

export const WorkspaceItemRight = styled.div`
  display: flex;
  align-items: center;
  
  button {
    visibility: hidden;
  }
`;

export const WorkspaceItem = styled.div`
  display: flex;
  min-height: 56px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  
  &:hover {
    background: ${props => props.theme.colors.ghostWhite};
    
    ${WorkspaceItemRight} button {
      visibility: visible;
    }
    
    ${WorkspaceItemRight} ${CurrentWorkspaceText} {
      visibility: visible;
    }
  }
`;

export const WorkspaceItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const WorkspaceAvatar = styled(Avatar)`
  width: 21px;
  height: 17px;
  flex-shrink: 0;
`;

export const WorkspaceAvatarWithInitials = styled.div`
  width: 21px;
  height: 17px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  
  & > div {
    width: 21px !important;
    height: 17px !important;
    min-width: 21px !important;
    min-height: 17px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`;